import { BoardsList, ColorModeButton } from '../..';

export const XsBoardsModal = () => {
   return (
      <>
         <BoardsList />
         <ColorModeButton />
      </>
   );
};
